<template>
  <v-navigation-drawer app v-model="drawer">
    <v-list nav>
      <!-- Logo and title -->
      <v-list-item id="logoListItem" to="/">
        <v-list-item-avatar class="elevation-2">
          <v-img src="@/assets/logo/logo.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title>
          NPMC
        </v-list-item-title>
      </v-list-item>

      <!-- User name -->
      <v-list-item v-if="user">
        <v-list-item-title
          ><v-icon class="account-icon">mdi-account</v-icon>
          {{ user.name | getFirstLetter }}. {{ user.surname }}
        </v-list-item-title>
      </v-list-item>
      <v-divider />

      <!-- Links -->
      <v-list-item
        v-for="link in navigationLinks"
        :key="link.title"
        link
        :to="link.to"
      >
        <v-list-item-content>
          <v-list-item-title>{{ link.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <!-- If user has signed in show change pass and sign out -->
      <template v-if="user">
        <v-list-item link @click="$store.state.resetPasswordDialog = true">
          <v-list-item-content>
            <v-list-item-title>Change password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-content>
            <v-list-item-title>Sign out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <!-- If user not signed in show sign in -->
      <v-list-item v-else link to="/signin">
        <v-list-item-content>
          <v-list-item-title>Sign in</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<style scoped>
#logoListItem:hover::before {
  background: none;
  transition: none;
}
#logoListItem::before {
  background: none;
  transition: none;
}
.account-icon {
  bottom: 2px;
  margin-right: 4px;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user", "navigationLinks"]),
    drawer: {
      get: function() {
        return this.$store.state.navDrawer;
      },
      set: function(value) {
        this.$store.state.navDrawer = value;
      }
    }
  },
  methods: {
    logout() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.$store.dispatch("userLogout");
    }
  },
  filters: {
    getFirstLetter: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase();
    }
  }
};
</script>
